
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.833 3.359h-1.666V1.692H12.5V3.36h-5V1.692H5.833V3.36H4.167c-.92 0-1.667.747-1.667 1.666v11.667c0 .92.748 1.667 1.667 1.667h11.666c.92 0 1.667-.748 1.667-1.667V5.025c0-.919-.747-1.666-1.667-1.666zM15 15.859h-5v-5h5v5zm.833-8.334H4.167V5.86h11.666v1.666z","fill":"#fff"}})])
          )
        }
      }
    